import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popup, Icon } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from 'react-datepicker'

class ParticipantsTable extends Component {
  constructor(props){
    super(props);

    this.state = {
      participants: this.props.participants,
      showDatePicker: false
    }

  }

  onAddParticipant = (evt) => {
    var new_participant = {
      name: "",
      role: "",
      company: "",
      date: new Date().toISOString().split('T')[0]
    }
    var participants = this.state.participants.concat(new_participant)
    this.setState({
      participants: participants
    })
  }

  onEditParticipant = (evt, index) => {

    var participant = this.state.participants[index]

    switch (evt.target.getAttribute("name")) {
      case "name":
        participant.name = evt.target.value;
        break;
      case "role":
        participant.role = evt.target.value;
        break;
      case "company":
        participant.company = evt.target.value;
        break;
      case "date":
        participant.date = evt.target.value;
        break;
      default:
    }
    var participants = this.state.participants
    participants[index] = participant
    this.setState({participants: participants})
  }


  onBlurParticipant = (evt) => {
    this.props.updateParticipants(this.state.participants)
  }

  onDeleteParticipant = (evt, index) => {
    this.state.participants.splice(index, 1);
    this.setState({
      participants: this.state.participants
    })
    this.props.updateParticipants(this.state.participants)
  }

  toggleCalendar = (show) => {
    this.setState({showDatePicker: show})
  }

  onDateSelection = (date, index) => {
    var participant = this.state.participants[index]
    participant.date = moment(date).format("DD MMM YYYY");
    this.state.participants[index] = participant
    this.toggleCalendar(false)
  }

  render() {
    const { name, role, company, date, add_participant } = this.props.translations
    const canEdit = this.props.isAdmin || (this.props.permission && this.props.permission.can_update)
    
    return (
      <div className="participants-container">
        {
          this.state.participants.length > 0 &&
          <table className="participants">
            <thead>
              <tr>
                <th>{name}</th>
                <th className="role">{role}</th>
                <th>{company}</th>
                <th>{date}</th>
                {  canEdit && <th className="delete"></th> }
              </tr>
            </thead>
            <tbody>
            { this.state.participants.length > 0 &&
              this.state.participants.map((participant, index) => {
                const cantEdit = !canEdit
                return (
                  <tr key={index}>
                    <td>
                      <input type="text" name="name"
                             disabled={cantEdit}
                             onChange={(evt) => this.onEditParticipant (evt, index)}
                             value={participant.name}
                             style={{opacity: 1}}
                             onBlur={this.onBlurParticipant}/>
                    </td>
                    <td>
                      <input type="text" name="role"
                             disabled={cantEdit}
                             onChange={(evt) => this.onEditParticipant (evt, index)}
                             value={participant.role}
                             style={{opacity: 1}}
                             onBlur={this.onBlurParticipant}/>
                    </td>
                    <td>
                      <input type="text" name="company"
                             disabled={cantEdit}
                             onChange={(evt) => this.onEditParticipant (evt, index)}
                             value={participant.company}
                             style={{opacity: 1}}
                             onBlur={this.onBlurParticipant}/>
                    </td>
                    <td className="date">
                      <div className="participants-input-date">
                        <div className="text">{ participant.date.length > 0 && moment(participant.date).format("DD MMM YYYY") }</div>
                        { canEdit &&
                          <div className="picker">
                            <Popup
                              open={this.state.showDatePicker === index}
                              trigger={ <Icon name='calendar alternate' link circular inverted bordered/> }
                              content= {
                                <div>
                                  <DatePicker
                                    onChange={ (date) => this.onDateSelection(date, index) }
                                    inline
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    yearDropdownItemNumber={3}
                                  />
                                </div>
                              }
                              onOpen={ () => this.toggleCalendar(index) }
                              onClose={ () => this.toggleCalendar(false) }
                              on='click'
                              position="bottom left"
                              basic
                              hoverable
                              flowing
                            />
                          </div>
                        }
                      </div>
                    </td>
                    { canEdit &&
                      <td className="delete" onClick={(evt) => this.onDeleteParticipant (evt, index)}><i className='trash alternate outline icon' /></td>
                    }
                  </tr>
                )
              })
            }
            </tbody>
          </table>
        }
        {  canEdit &&
          <label className="new-participant" onClick={ this.onAddParticipant }><i className='user plus icon' />
            <u>&nbsp;{add_participant}</u>
          </label>
        }
      </div>

    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ParticipantsTable)



// WEBPACK FOOTER //
// ./src/components/participants_table.js